import React from 'react';
import { Stack,  Typography , Container } from "@mui/material";

const SubmissionSuccess = () => {
  return (
    <Container maxWidth="lg" sx={{mt: "5%", mb: "5%"}}>
      <Typography variant="h3" gutterBottom>Form Submitted Successfully!</Typography>
      <Typography variant="h5" gutterBottom>Thank you for your submission.</Typography>
      <Typography variant="h5" gutterBottom>You will soon receive an email notification. If not, please check your spam folder.</Typography>
    </Container>
  );
};

export default SubmissionSuccess;